import { ReactNode } from 'react'
import './snackbar.scss'

interface Props {
  status?: 'success' | 'failed'
  children: ReactNode
  showSnackbar?: boolean
  role?: 'status' | 'alert'
  compact?: boolean
}

const SnackbarWrapper = ({ status, children, showSnackbar = true, role, compact = false }: Props) => {
  return (
    <div
      className={`snackbarWrapper ${compact ? 'snackbarWrapper--compact' : ''} ${showSnackbar ? '' : 'snackbarWrapperSlideOut'}`}
      data-status={status}
      role={role}
    >
      {children}
    </div>
  )
}

export default SnackbarWrapper
